<template>
    <nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white" id="sidenav-main">
        <div class="container-fluid">
            <!--Toggler-->
            <navbar-toggle-button @click.native="showSidebar">
                <span class="navbar-toggler-icon"></span>
            </navbar-toggle-button>

            <div class="d-md-none text-center">
                <div class="h2 mb-0 text-body">{{entidade.ent_nome}} - {{entidade.ent_uf}}</div>
            </div>

            <div class="d-md-none"></div>

            <slot></slot>
            <div v-show="$sidebar.showSidebar" class="navbar-collapse collapse show" id="sidenav-collapse-main">

                <div class="navbar-collapse-header d-md-none">
                    <div class="row">
                        <div class="col-6 collapse-brand">
                            <router-link to="/">
                                <div class="h2 mb-0 text-body"> Diário Oficial Eletrônico </div>
                            </router-link>
                        </div>
                        <div class="col-6 collapse-close">
                            <navbar-toggle-button @click.native="closeSidebar"></navbar-toggle-button>
                        </div>
                    </div>
                </div>

                <ul class="navbar-nav">
                    <slot name="links">
                    </slot>
                </ul>
                <!--Divider-->
                <hr class="my-3">
                <!--Heading-->
                <h6 class="navbar-heading text-muted" title="Informações">Informações</h6>
                <!--Navigation-->
                <ul class="navbar-nav mb-md-3">
                    <li class="nav-item">
                        <router-link ref="link"
                                     title="Fale Conosco"
                                     class="nav-link"
                                     :to="{name: 'faleconosco'}">
                            <i class="far fa-comments"></i> Fale Conosco
                        </router-link>
                    </li>
                    <li v-show="false" class="nav-item">
                        <a class="nav-link"
                           title="Legislação"
                           href="https://demos.creative-tim.com/vue-argon-dashboard/documentation/foundation/colors.html">
                            <i class="far fa-copy"></i> Legislação
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link"
                           target="_blank"
                           title="Site da entidade"
                           v-bind:href="entidade.ent_site">
                            <i class="fas fa-external-link-alt"></i> Site Oficial
                        </a>
                    </li>
                </ul>
            </div>
            </div>
    </nav>
</template>
<script>
  import NavbarToggleButton from '@/components/NavbarToggleButton'

  export default {
    name: 'sidebar',
    components: {
      NavbarToggleButton
    },
    props: {
      logo: {
        type: String,
        default: 'img/brand/green.png',
        description: 'Sidebar app logo'
      },
      autoClose: {
        type: Boolean,
        default: true,
        description: 'Whether sidebar should autoclose on mobile when clicking an item'
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      };
    },
    methods: {
      closeSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      showSidebar() {
        this.$sidebar.displaySidebar(true)
      }
    },
    beforeDestroy() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false;
      }
    },
    computed: {
      entidade() {
        return this.$store.getters.entidade;
      }
    }
  };
</script>
